import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Box } from 'reflexbox/styled-components'
import theme from 'theme'

const ContainerDiv = styled(Box)`
  width: 100%;
  box-sizing: border-box;
`

const Container = ({
  maxWidth,
  verticalPadding,
  children,
  style,
  className,
  renderAs,
  ...others
}) => {
  const compStyle = { maxWidth, ...style }

  if (!verticalPadding) {
    compStyle.paddingTop = 0
    compStyle.paddingBottom = 0
  }

  if (others?.p == null) {
    compStyle.padding = '20px 20px 50px 20px'
  }

  if (others?.m == null && others?.ml == null) {
    compStyle.margin = '0 auto'
  }

  return (
    <ContainerDiv
      as={renderAs}
      className={className}
      style={compStyle}
      {...others}
    >
      {children}
    </ContainerDiv>
  )
}

export const underscoreStyles = css`
  &: ${({ before }) => (before ? 'before' : 'after')} {
    content: '';
    display: block;
    height: 2px;
    width: 63px;
    background: ${theme.colors.black};
  }
`

const getAttrs = (props) => ({
  p: 0,
  m: 0,
  maxWidth: 30000,
  ...props,
})

export const DefaultContainer = styled(Container).attrs(getAttrs)`
  padding-bottom: 0 !important;
  width: 100%;
`

export const UnderscoreContainer = styled(DefaultContainer)`
  ${underscoreStyles}
`

Container.defaultProps = {
  verticalPadding: true,
  maxWidth: 560,
  className: null,
}

Container.propTypes = {
  verticalPadding: PropTypes.bool,
  maxWidth: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Container
